var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.31055,131.25647c-.41992.94531-10.54688,23.37207-33.35938,43.80566a8.00126,8.00126,0,0,1-11.25781-.57715L101.40234,63.06506a8.00028,8.00028,0,0,1,4.60254-13.27246A133.97063,133.97063,0,0,1,128,47.99963c34.87793,0,66.57324,13.26075,91.65723,38.34766,18.834,18.83594,27.30175,37.62109,27.65332,38.41113A8.00282,8.00282,0,0,1,247.31055,131.25647ZM213.91992,210.6178a8.0006,8.0006,0,0,1-11.83984,10.76367l-22.01441-24.21582A126.97091,126.97091,0,0,1,128,207.99963c-34.87793,0-66.57227-13.25781-91.65625-38.33886-18.834-18.832-27.30273-37.61329-27.6543-38.4043a8.00282,8.00282,0,0,1,0-6.49805c.69556-1.564,16.31079-35.9209,52.63184-58.21191l-19.24121-21.165A8.0006,8.0006,0,1,1,53.91992,34.6178ZM145.6814,159.34289l-47.20459-51.9248a35.98114,35.98114,0,0,0,47.20459,51.9248Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye_slash.a33c9fc5d699d628fd28f6699becf3bb.svg";
export { ForwardRef as ReactComponent };